import React, { useContext, useState } from "react";
import "./register.css";
import logo from "../../assets/logo.png";
import show from "../../assets/show.png";
import hide from "../../assets/hide.png";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import axios from "axios";
import CodeInput from "../../components/CodeInput/CodeInput";
import { AuthContext } from "../../context/auth-context";

const Register = () => {
  const { authenticate } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const [data, setData] = useState({
    name: "",
    surname: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [step, setStep] = useState(1);
  const [inputValue, setInputValue] = useState();

  const changeData = (e) => {
    const { name, value } = e.target;

    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleContinue = async () => {
    setError("");
    if (data.name === "") {
      setError("Please enter your name.");
      return;
    } else if (data.surname === "") {
      setError("Please enter your surname.");
      return;
    } else if (data.email === "") {
      setError("Please enter your email address.");
      return;
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      setError("Please enter a valid email address.");
      return;
    } else if (data.password === "") {
      setError("Please enter your password.");
      return;
    } else if (data.password.length < 8) {
      setError("Password must be longer than 8 characters..");
      return;
    } else if (data.confirmPassword === "") {
      setError("Please confirm your password.");
      return;
    } else if (data.password !== data.confirmPassword) {
      setError("Your passwords do not match.");
      return;
    }

    try {
      setLoading("sendCode");

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/member/check-user-exists`,
        { email: data.email }
      );

      setStep(2);
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  const register = async () => {
    try {
      setError("");
      setLoading("register");

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/member/register`,
        { code: inputValue, userData: data }
      );

      authenticate(response.data.token);
      window.location.reload();
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-header-div">
        <img className="login-header-img" src={logo} />
      </div>

      {step === 1 && (
        <div className="login-form-div">
          <h1 className="login-form-h">Create your account</h1>
          <p className="login-form-p">Enter your details below</p>

          <input
            maxLength={20}
            value={data.name}
            onChange={changeData}
            name="name"
            className="regular-input mb-16"
            placeholder="Name"
            type="text"
          />
          <input
            maxLength={20}
            value={data.surname}
            onChange={changeData}
            name="surname"
            className="regular-input mb-16"
            placeholder="Surname"
            type="text"
          />
          <input
            maxLength={30}
            value={data.email}
            onChange={changeData}
            name="email"
            className="regular-input mb-16"
            placeholder="Email address"
            type="email"
          />

          <div className="password-input-div mb-16">
            <input
              maxLength={20}
              value={data.password}
              onChange={changeData}
              name="password"
              className="regular-input"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
            />
            <img
              onClick={() => {
                setShowPassword((prevState) => !prevState);
              }}
              className="password-input-icon"
              src={showPassword ? hide : show}
            />
          </div>

          <div className="password-input-div">
            <input
              maxLength={20}
              value={data.confirmPassword}
              onChange={changeData}
              name="confirmPassword"
              className="regular-input"
              placeholder="Confirm Password"
              type={showConfirmPassword ? "text" : "password"}
            />
            <img
              onClick={() => {
                setShowConfirmPassword((prevState) => !prevState);
              }}
              className="password-input-icon"
              src={showConfirmPassword ? hide : show}
            />
          </div>

          <div
            onClick={loading === "sendCode" ? null : handleContinue}
            className="login-form-button"
          >
            {loading === "sendCode" ? (
              <ClipLoader size={20} color={"#fff"} />
            ) : (
              "Continue"
            )}
          </div>
          {error && <p className="login-form-error-p">{error}</p>}
        </div>
      )}

      {step === 2 && (
        <div className="login-form-div">
          <h1 className="login-form-h">Verify your email</h1>
          <p className="login-form-p">Enter code your recieved on your email</p>

          <CodeInput setInputValue={setInputValue} />

          <div
            onClick={loading === "register" ? null : register}
            className="login-form-button"
          >
            {loading === "register" ? (
              <ClipLoader size={20} color={"#fff"} />
            ) : (
              "Register"
            )}
          </div>
          {error && <p className="login-form-error-p">{error}</p>}
        </div>
      )}

      <div className="login-dont-div">
        <p className="login-dont-div-p">Already have an account?</p>
        <Link to={"/login"} className="login-dont-div-link">
          Log in
        </Link>
      </div>
    </div>
  );
};

export default Register;
